import { computed, inject, Injectable, signal } from "@angular/core";
import { WINDOW_TOKEN } from "@kno2/core/browser";

@Injectable({
    providedIn: "root"
})
export class LoadingIndicatorService {
    private readonly window = inject(WINDOW_TOKEN);
    private loadingRoutes = signal<string[]>([]);
    private loading = signal<boolean>(false);

    public isLoading = computed(() => this.loadingRoutes().length > 0 || this.loading());

    public addRoute(route: string): void {
        this.loadingRoutes.update((routes) => [...routes, route]);
    }

    public removeRoute(route: string): void {
        this.loadingRoutes.update((routes) => routes.filter((r) => r !== route));
    }
}
